interface CustomErrorResI {
  response?: {
    data?: string | { message?: string; errors?: string[] };
  };
}
const getErrorMessage = (
  error: CustomErrorResI | Error | unknown,
) => {
  console.error(
    '>>>> error',
    error,
    'error.response',
    (error as CustomErrorResI).response,
  );
  let result;
  if (!!(error as CustomErrorResI).response) {
    const response = (error as CustomErrorResI).response;
    if (typeof response?.data === 'string') {
      result = response.data;
    } else {
      result = response?.data?.errors || response?.data?.message;
    }
  }
  return result || `${error}`;
};
export default getErrorMessage;
